import PublicReport from '../../components/PublicReport'

/**
 * Die beiden offenen Fassungen des Jahresberichts.
 *
 * Beide zeigen dasselbe Schuljahr, aber für verschiedene Leser:innen — deshalb
 * zwei Adressen und nicht ein Umschalter im Dokument. Wer die Bilanz sucht,
 * soll nicht erst an einer Reiterleiste vorbei.
 *
 * Die vollständige Bilanz mit den finanziellen Ergebnissen liegt weiterhin
 * unter `/jahresbericht` und bleibt der Bundesadministration vorbehalten.
 */

/** Die Junior-Bilanz ohne finanzielle Ergebnisse — verlinkt aus dem Aufmacher
 *  der Startseite und von der Unterstützer:innen-Seite. */
export function PublicAnnualReport() {
	return (
		<PublicReport
			bericht="bilanz"
			kicker="Junior Achievement Austria · Schuljahr 2025/26"
			title={'Junior-Bilanz\n2025/26'}
			subtitle="Was 4.966 Schüler:innen in 592 Junior Companies auf die Beine gestellt haben — vom Anlegen über die Freigabe und die Berichte bis zur Urkunde. Öffentliche Fassung ohne finanzielle Ergebnisse, exkl. Junior Mini Companies."
		/>
	)
}

/** Was die Anwendung selbst leistet — verlinkt aus dem DaVinciLab-Steckbrief
 *  in der Fußzeile. */
export function PublicPlatformReport() {
	return (
		<PublicReport
			bericht="plattform"
			kicker="Junior Datenbank · Plattform und Betrieb"
			title={'Die Plattform\nhinter Junior'}
			subtitle="Wie eine Initiative dieser Größe durch ein Schuljahr kommt: Automatismen statt Nachfragen, Dokumente ohne Handarbeit, drei Ebenen der Prüfung und eine Änderung, die nachweisbar ist. Umsetzung und Betrieb: DaVinciLab."
		/>
	)
}
